/**
 * Created by Mark on 01/12/2016.
 */

/**
 * Created by Mark on 01/12/2016.
 */


import React from "react";
import SingleInput from '../inputs/single.input.js';

export default class TableBody extends React.Component {

    constructor(props){
        super();

        this.state = {
            rows : props.rows || [],
            editaction : props.editaction || false,
            deleteaction: props.deleteaction || false
        }

        if (props.editButtonText != undefined) {
            this.editButtonText = props.editButtonText;
        } else {
            this.editButtonText = "...";
        }

    }

    handelChange(rowIndex , colIndex , e){
        var rows = this.state.rows;
        rows[rowIndex][colIndex].value = e.target.value
        this.setState({rows:rows})
    }

    renderColumns(row , rowIndex){
        var columns = [];


        for(var idx = 0 ; idx < row.length; idx++)
        {
            columns.push(<td  className={row[idx].className} >
                {row[idx].value}
            </td>)
        }

        if (this.state.editaction != false) {
            columns.push(<td width="50" className="text-right">

                <button onClick={function(){
                    this.state.editaction(row)}.bind(this)
                } type="button"className="btn btn-icon command-delete waves-effect waves-circle" data-row-id="10253"><span className="zmdi zmdi-edit"></span></button>

            </td>);
        }

        if (this.state.deleteaction != false) {
            columns.push(<td width="50"  className="text-right">
                <button onClick={function(){
                    this.state.deleteaction(row)}.bind(this)
                } type="button"className="btn btn-icon command-delete waves-effect waves-circle" data-row-id="10253"><span className="zmdi zmdi-delete"></span></button>
            </td>);
        }

        return columns;
    };

    enableRowEdit(){

    }

    renderRows(){

        var rows = [];

        for(var idx = 0; idx <  this.state.rows.length;  idx++)
        {
            rows.push(
                <tr>
                    {this.renderColumns(this.state.rows[idx] , idx)}
                </tr>
            )
        }

        return rows;
    }

    componentWillReceiveProps(props){

        this.setState({
            rows:props.rows
        })
    }

    render(){
        return (
            <tbody>
                { this.renderRows() }
            </tbody>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/tables/table.body.component.js